import React, { useState, useCallback, useEffect } from 'react';
import { inject, observer } from 'mobx-react';
import { makeStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom';
import { FormControlLabel, Grid, InputAdornment, TextField, Typography } from '@material-ui/core';

import { ButtonClearInput, CustomCheckbox} from '../../button';

import { ImgArrowL } from '../../../static/images';
import NumberOfFloors from './NumberOfFloors';
import { AddressSearchDialog } from '../../address';
import QuickFillButton from './QuickFillButton';
import SideFields, { sideValues } from './SideFields';

const useStyles = makeStyles(() => ({
  root: {
    paddingTop: 50,
    '& .textBox': {
      '& .Mui-disabled': {
        borderColor: 'transparent !important',
        
      },
      '& .MuiOutlinedInput-notchedOutline': {
        borderRadius: '8px !important'
      },
      '& .MuiInputBase-root': {
        boxShadow: 'none',
        marginBottom: 16,
        width: 370,
        // height: 50,
        padding: '0 16px',
        borderRadius: 8,
        border: 'solid 1px #e4e4e9',
        backgroundColor: '#ffffff',
        '& input': {
          height: 50,
          '&::-webkit-input-placeholder': {
            color: '#cacacf'
          }
        },
        '& textarea': {
          '&::-webkit-input-placeholder': {
            color: '#cacacf'
          }
        },
        '& .MuiOutlinedInput-input': { padding: 0 },
      },
    },
   
    '& .MuiTextField-root': {
      '& .MuiInputBase-multiline': {
        padding: '12px 16px !important;',
      }
    },
    '& .nameText': {
      '& .MuiInputBase-root': {
        width: '130px !important;',
        marginRight: 10,
      },
    },
    '& .phoneText': {
      '& .MuiInputBase-root': {
        width: '233px !important;',
      },
    },
    '& .startAddr': { width: 'auto'},
    '& .endAddr': { width: 'auto'},
    '& .arrowIcon': {
      width: 60,
      height: 60,
      marginTop: 114,
    },
    '& .requesterPhone': {
      '& .MuiInputBase-root': {
        width: 373,
        '& label': {
          width: '100% !important;'
        }
      },
      
    }
  },
  tremDetBtn: {
    cursor: 'pointer',
    marginLeft: 10,
    borderBottom: '1px solid #ff925c'
  }
}));

const params = {};

function Address({ type, cmStore, qsStore, loginStore, history }) {
  const classes = useStyles();
  const { handleOptions, orderCalAPI } = qsStore;
  const { userInfo } = loginStore;
  const { toAddress, toBcode, fromAddress, etcAddress, setEtcAddress, setDaumAddress, initialAddress, requester } = cmStore;

  const [same, setSame] = useState(false);
  const [addrOpen, setAddrOpen] = useState(false);
  const [requestTel, setStartTel] = useState("");
  const [addresstype, setAddressType] = useState("to");

  useEffect(() => {
    let orderType = "";
    if (type === 'quick') orderType = 'Quick';
    else if (type === 'cargo') orderType = 'Freight';
    else orderType = 'Move';
    handleOptions("orderType", orderType);

    if (!etcAddress.startAddrDtl) initialAddress();
  }, [])

  useEffect(() => {
    if (toAddress && fromAddress ) {
      orderCalAPI();
    }
  }, [toAddress, fromAddress])

  const handleAddrOnOff = useCallback((type) => {
    setAddressType(type);
    setAddrOpen(!addrOpen)
  }, [addrOpen]);

  const handleChange = (e, checked) => {
    let value = e.target.value;
    const name = e.target.name;
    params[name] = value;

    if (name === "agree") {
      if (checked) value = "Y"
      else value = "N"
    }
    
    setEtcAddress(name, value);
    handleOptions(name, value);
    

    if (name === "startTel" && same) {
      setStartTel(value);

    } else if (name === "same") {
      if (!same) {
        setStartTel(etcAddress.startTel);
        handleOptions('requestTel', etcAddress.startTel);
      }
      setSame(!same);

    } else if (name === "requestTel") {
      setStartTel(value);
    }

  }

  const handlePage = (path) => {
    if (path === '/policy') {
      history.push({
        pathname: path,
        state: { type: 'privacy' }
      })
    } else {
      history.push(path);
    }
  }

  // 불러오기 — 의뢰자 정보를 출발지/도착지에, 출발지 정보를 도착지에 복사한다 (롯데홈쇼핑 '의뢰자로 불러오기')
  const fillSide = (side, src) => {
    setDaumAddress(side === 'start' ? 'to' : 'from', src.addr || '', src.bcode || '');
    Object.entries(sideValues(side, src)).forEach(([key, value]) => {
      setEtcAddress(key, value || '');
      handleOptions(key, value || '');
    });
  };
  const fillFromRequester = (side) => fillSide(side, {
    addr: requester.addr, bcode: requester.bcode, addrDtl: requester.addrDtl,
    company: requester.company, dept: requester.dept, name: requester.name, tel: requester.tel,
  });
  const fillFromStart = () => fillSide('end', {
    addr: toAddress, bcode: toBcode, addrDtl: etcAddress.startAddrDtl,
    company: etcAddress.startCompany, dept: etcAddress.startDept, name: etcAddress.startNm, tel: etcAddress.startTel,
  });
  const hasRequester = Boolean(requester.addr || requester.name || requester.tel);

  return (
    <React.Fragment>
      <AddressSearchDialog type={addresstype} open={addrOpen} handleClose={handleAddrOnOff} />
      <Grid className={classes.root} container direction="row" justify="flex-start" alignItems="flex-start">
        <Grid className="startAddr" container direction="column" justify="flex-start" alignItems="flex-start">
          <Typography variant="subtitle2" color="textPrimary" gutterBottom><b>출발지</b></Typography>
          <div>
            <QuickFillButton icon="user" disabled={!hasRequester} onClick={() => fillFromRequester('start')}>의뢰자 정보 불러오기</QuickFillButton>
          </div>
          <TextField
            disabled
            InputProps={{
              endAdornment: (
                <InputAdornment position="end"><ButtonClearInput /></InputAdornment>
              ),
            }}
            placeholder="주소를 검색하세요."
            variant="outlined"
            className="formArea textBox"
            value={toAddress}
            onClick={() => handleAddrOnOff('to')}
          />
          <TextField
            className="formArea textBox"
            placeholder="상세 주소를 입력하세요."
            multiline
            // rowsMax={2}
            rows={2}
            variant="outlined"
            name="startAddrDtl"
            value={etcAddress.startAddrDtl}
            onChange={handleChange}
          />
          <SideFields side="start" values={etcAddress} onChange={handleChange} />
          {type === 'move' && <NumberOfFloors name="moveStartType" subName="startFloor" />}

        </Grid>
        <div className="arrowIcon">
          <img alt="" src={ImgArrowL} />
        </div>
        <Grid className="endAddr" container direction="column" justify="flex-start" alignItems="flex-start">
          <Typography variant="subtitle2" color="textPrimary" gutterBottom><b>도착지</b></Typography>
          <div>
            <QuickFillButton icon="user" disabled={!hasRequester} onClick={() => fillFromRequester('end')}>의뢰자 정보 불러오기</QuickFillButton>
            <QuickFillButton icon="copy" disabled={!toAddress} onClick={fillFromStart}>출발지 정보 불러오기</QuickFillButton>
          </div>
          <TextField
            disabled
            InputProps={{
              endAdornment: (
                <InputAdornment position="end"><ButtonClearInput /></InputAdornment>
              ),
            }}
            placeholder="주소를 검색하세요."
            variant="outlined"
            className="formArea textBox"
            value={fromAddress}
            onClick={() => handleAddrOnOff('from')}
          />
          <TextField
            className="formArea textBox"
            placeholder="상세 주소를 입력하세요."
            multiline
            // rowsMax={2}
            rows={2}
            variant="outlined"
            name="endAddrDtl"
            value={etcAddress.endAddrDtl}
            onChange={handleChange}
          />
          <SideFields side="end" values={etcAddress} onChange={handleChange} />
          {type === 'move' && <NumberOfFloors name="moveEndType" subName="endFloor" style={{ marginBottom: 16 }} />}
          {
            !userInfo && (
              <Grid item>
                <Grid container direction="row" justify="flex-start" alignItems="center">
                  <FormControlLabel
                    control={
                      <CustomCheckbox
                        name="agree"
                        onChange={handleChange}
                      />
                    }
                    label={
                      <Typography variant="body2" color="textPrimary">
                        개인정보 수집 이용 동의
                            </Typography>
                    }
                  />
                  <Typography
                    className={classes.tremDetBtn}
                    variant="caption"
                    color="primary"
                    onClick={() => handlePage('/policy')}
                  >
                    상세보기
                  </Typography>
                </Grid>
              </Grid>
            )
          }
        </Grid>
      </Grid>
    </React.Fragment>
  );
}

export default inject('cmStore', 'qsStore', 'loginStore')(withRouter(observer(Address)));